module.exports = __webpack_public_path__ + "img/money-simple-from-bracket.679b1e9a.svg";